<template>
  <div style="height:calc(100vh - 305px);">
    <div class="shape" ref="scenePie"></div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
      option: {}
    }
  },
  computed: {
    pieLocation () {
      const winWidth = document.documentElement.clientWidth
      if (winWidth > 1600) {
        return [
          ['50%', '30%'],
          ['50%', '80%']
        ]
      }
      return [
        ['30%', '50%'],
        ['70%', '50%']
      ]
    },
    setOption: {
      get () {
        return ''
      },
      set (val) {
        const pie01 = val.orderMonthScatter.list
        const pie02 = val.orderDeliveryCycleScatter.list
        const colorOpt = {}
        colorOpt['紧急及超期'] = 'rgb(239,92,100)'
        colorOpt['即将超期'] = 'rgb(45,159,209)'
        colorOpt['正常'] = 'rgb(96,199,170)'
        const normalizeDeliveryLabel = (label) => {
          const labelMap = {}
          labelMap['超期'] = '紧急及超期'
          labelMap['警告'] = '紧急及超期'
          labelMap['预警'] = '即将超期'
          labelMap['正常'] = '正常'
          labelMap['紧急及超期'] = '紧急及超期'
          labelMap['即将超期'] = '即将超期'
          return labelMap[label] || label
        }

        const axisData01 = pie01.map(v => ({ name: v.time, value: v.num }))
        const deliverySummaryMap = {}
        pie02.forEach((item) => {
          const currentLabel = normalizeDeliveryLabel(item.time)
          if (!colorOpt[currentLabel]) return
          deliverySummaryMap[currentLabel] = (deliverySummaryMap[currentLabel] || 0) + item.num
        })
        const axisData02 = Object.keys(deliverySummaryMap).map(key => ({
          name: key,
          value: deliverySummaryMap[key],
          color: colorOpt[key]
        }))

        this.option = {
          tooltip: {
            formatter: (param) => {
              const title = `<div>${param.seriesName}</div>`
              const value = `<div>${param.marker}${param.name} ${param.value} (${param.percent}%)</div>`
              return title + value
            }
          },
          series: [
            {
              type: 'pie',
              radius: 60,
              minAngle: 5,
              center: this.pieLocation[0],
              data: axisData01,
              name: '订单月份分布',
              label: {
                formatter: (param) => `${param.name} ${param.value}\n(${param.percent}%)`
              },
              color: ['rgb(45,159,209)', 'rgb(239,92,100)', 'rgb(96,199,170)', 'rgb(67,93,116)']
            },
            {
              type: 'pie',
              radius: 60,
              minAngle: 5,
              center: this.pieLocation[1],
              data: axisData02,
              name: '订单交期分布',
              label: {
                formatter: (param) => `${param.name} ${param.value} (${param.percent}%)`
              },
              itemStyle: {
                color: (params) => params.data.color
              }
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.setOption = this.data
    this.$nextTick(() => {
      this.render()
    })
  },
  methods: {
    render () {
      const chartInstance = this.$echarts.init(this.$refs.scenePie)
      chartInstance.setOption(this.option)
    }
  }
}
</script>

<style lang="stylus" scoped>
.shape
  height 100%
  background #ffffff
</style>
